export default Object.freeze({
  basic: 'BASIC',
  gcr: 'GCR',
  quay: 'QUAY',
});
